import Splide from "@splidejs/splide";

// Navigation
$('#menu-switcher').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container')
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $('#fade').css('opacity', 0);
    } else {
        $menu.removeClass('menu-active');
        $('#fade').css('opacity', 1);
    }
});

// Fetch all the details element.
const details = document.querySelectorAll("details");

// Add the onclick listeners.
details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        details.forEach((detail) => {
            if (detail !== targetDetail) {
                detail.parentElement.classList.remove("submenu-open");
                detail.removeAttribute("open");
            }
            if (detail === targetDetail) {
                detail.parentElement.classList.add("submenu-open");
            }
        });
    });
});

// Isotope Filtering
var idnum = 0
$('a.filter').on('click', function (event) {
    event.preventDefault()
    var $this = $(this),
        $set = $($this.data('set'))

    if (!$this.attr('id')) $this.attr('id', 'link_' + (idnum++))
    $set.isotope({
        filter: $this.data('filter'),
        layoutMode: 'fitRows',
    })
    $this.closest('ul').find('a.filter').removeClass('active')
    $this.addClass('active')

    var href = $this.attr('href')
    if (href != window.location.pathname) {
        history.pushState({
            'linkid': $this.attr('id')
        }, null, href)
    } else {
        history.replaceState({
            'linkid': $this.attr('id')
        }, null, href)

    }
}).filter('.active').trigger('click')

window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.linkid) return
    $('#' + event.state.linkid).trigger('click')
});

// Search Form
var searchField = $('#SearchForm_SearchForm_Search');
var default_value = searchField.val();
searchField.focus(function () {
    $(this).addClass('active');
    if (searchField.val() === default_value) {
        searchField.val('');
    }
});
searchField.blur(function () {
    if (searchField.val() === '') {
        searchField.val(default_value);
    }
});

searchField.attr('placeholder', 'Search...');

// Animations
var options = {
    animateClass: 'animate__animated',
    animateThreshold: 20,
    scrollPollInterval: 0
}
$('.aniview').AniView(options);

var addIntroLineBreaks = function () {
    $('.HomePage .banner-element__content h2, .HomePage .content-element__title, .HomePage .video-block-title').each(function () {
        //$(this).find('br').remove()
        $(this).text($(this).text().trim())
            $(this).children().remove()
        var $temp = $('<h2 class="video-block-title"/>').css({
                'position': 'absolute',
                'white-space': 'nowrap',
                'width': 'auto',
            }).insertAfter(this),
            $this = $(this),
            words = $(this).text().split(' '),
            maxwidth = $this.width(),
            lines = [],
            line = []
        $.each(words, function (i, word) {
            $temp.text($temp.text() + ' ' + word)
            maxwidth -= 2
            if ($temp.width() > maxwidth) {
                lines.push(line.join(' '))
                line = []
                maxwidth = $this.width()
                $temp.text(word)
            }
            line.push(word)
        })
        if (line.length) lines.push(line.join(' '))
        $(this).html('<div class="appearletters">' + lines.join(' </div><div class="appearletters">') + '</div>')
        $temp.remove()
    })
}

var changeProjectNameWidths = function () {
    $('.grid-item h3').each(function () {
        var $item = $(this).closest('.grid-item').addClass('forcevisible')
        $(this).width('100%');
        let temp = $('<h3/>').css({
                'font-family': 'PlayfairDisplay'
            }).text($(this).text()).width($(this).width()).append($('.body')),
            height = temp.height(),
            width = temp.width();


        while (width > 100 && $(this).height() == height) {
            $(this).width(--width);
        }
        $(this).width(width);
        $item.removeClass('forcevisible')
    });
}

$(window)
    .on('resize', changeProjectNameWidths)
    .on('resize', addIntroLineBreaks)
    .on('load', function() {
        addIntroLineBreaks()
        changeProjectNameWidths()
        $('div.appearletters').each(function () {
            var find = /([A-Za-z0-9,.])(?![^<]*>|[^<>]*<\/)/g,
                replace = '<span>$1</span>'
            $(this).children().each(function () {
                $(this).html($(this).html().replace(find, replace))
            })
            $(this).html($(this).html().replace(find, replace))
            var i = 0
            $(this).find('span').css({
                'display': 'inline-block',
                '--animate-duration': '0.3s',
                'position': 'relative',
                'opacity': 0,
            })
            $(this).parent().css('opacity', 1)
            var elems = $(this).find('span').toArray().reverse(),
                revealNext = function () {
                    var elem = elems.pop()
                    if (elem) {
                        $(elem).addClass('animate__fadeInUp')
                        $(elem).addClass('animate__animated')
                    }
                    if (elems.length) window.setTimeout(revealNext, 10)
                }
            revealNext()
        })
        $('.banner .splide').each(function() {
            var splide = new Splide(this, {
                perPage: 1,
                rewind: true,
                pagination: false,
                heightRatio: .5,
                pauseOnHover: true,
                pauseOnFocus: true,
                cover: true,
                breakpoints: {
                    1100: {
                        fixedHeight: 450,
                        fixedWidth: '100%'
                    },
                    500: {
                        fixedHeight: 350
                    }
                }
            });
            splide.mount();
        })

        $('.splide.home').each(function() {
            var splide = new Splide(this, {
                perPage: 1,
                rewind: true,
                pagination: false,
                heightRatio: .5,
                pauseOnHover: true,
                pauseOnFocus: true,
                cover: true,
                autoplay: true,
                speed: 3000,
                breakpoints: {
                    475: {
                        height: 'auto',
                        fixedHeight: 'auto'
                    }
                }
            });
            splide.mount();
        })

        $('.splide.people').each(function() {
            var splide = new Splide(this, {
                perPage: 1,
                rewind: true,
                pagination: false,
                height: 'auto',
                pauseOnHover: true,
                pauseOnFocus: true,
                cover: true,
                autoplay: true,
                speed: 3000,
                arrows: false,
                width: 1100,
                gap: '2em',
                trimSpace: true,
                breakpoints: {
                    1100: {
                        fixedHeight: 'auto'
                    },
                    500: {
                        fixedHeight: 'auto'
                    }
                }
            });
            splide.mount();
        })


    })

